var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 25,
    viewBox: "0 0 14 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5696 4.24955C11.4288 4.14875 12.2976 4.12955 13.2864 4.06715C13.2864 2.91035 13.296 1.51835 13.2672 0.347153C13.2672 0.347153 13.032 0.303952 12.888 0.279952C11.2704 0.0495518 9.648 -0.185648 8.0304 0.222352C5.5728 0.846352 4.0464 2.79995 3.9936 5.40635C3.9648 6.71675 3.9888 8.02715 3.9888 9.45275C2.9424 9.45275 1.0896 9.46235 0 9.43355C0.0336 10.6864 0.0192004 12.7216 0.0192004 13.9696H3.9264V24.736L8.8128 24.7216V13.9936C9.6912 13.9936 11.4288 13.984 12.4416 14.0176C12.4416 13.9984 12.4416 13.9792 12.4416 13.9552C12.5952 12.712 12.8832 10.8208 13.08 9.48155H8.6928C8.784 8.12315 8.7888 6.84155 8.9808 5.59355C9.1104 4.81115 9.768 4.34555 10.5696 4.24955Z",
    fill: "#22A081"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.b80e8a522f8157de8d825d4830d51521.svg";
export { ForwardRef as ReactComponent };